<template>
  <el-dialog
    title="逻辑树"
    :visible.sync="visible"
    @close="onClose"
    width="1000px"
    :fullscreen="fullscreen">
    <div style="width: 100%;">
      <diagram ref="diag"
               v-bind:model-data="diagramData"
               style="width:100%;"></diagram>
    </div>

    <span slot="footer"
          class="dialog-footer">
         <!--<el-button @click="makeImage()">生成图片</el-button>-->
      <el-button @click="handleAction('cancel')">关 闭</el-button>
    </span>
  </el-dialog>
</template>


<script>
import diagram from './diagram'

export default {
  components: {
    diagram,
  },
  props: {},
  data () {
    return {
      visible: false,
      action: '',
      loading: false,
      key: null,
      diagramData: {},
      currentNode: null,
      savedModelText: '',
      counter: 1, // used by addNode
      counter2: 4, // used by modifyStuff
      fullscreen: true, // 全屏
    }
  },
  mounted () {
  },
  computed: {
    currentNodeText: {
      get: function () {
        let node = this.currentNode
        if (node instanceof window.go.Node) {
          return node.data.text
        } else {
          return ''
        }
      },
      set: function (val) {
        let node = this.currentNode
        if (node instanceof window.go.Node) {
          let model = this.model()
          model.startTransaction()
          model.setDataProperty(node.data, 'text', val)
          model.commitTransaction('edited text')
        }
      },
    },
  },
  methods: {
    // get access to the GoJS Model of the GoJS Diagram
    model: function () {
      return this.$refs.diag.model()
    },
    // tell the GoJS Diagram to update based on the arbitrarily modified model data
    updateDiagramFromData: function () {
      this.$refs.diag.updateDiagramFromData()
    },
    makeImage: function () {
      this.$refs.diag.makeAImage()
    },
    // this event listener is declared on the <diagram>
    modelChanged: function (e) {
      if (e.isTransactionFinished) { // show the model data in the page's TextArea
        this.savedModelText = e.model.toJson()
      }
    },
    handleAction (action, value) {
      this.action = action
      this.doClose(value)
    },
    onClose () {
      if (!this.visible) return
      this.handleAction('close')
    },
    doClose (value) {
      if (!this.visible) return
      this.visible = false
      setTimeout(() => {
        if (this.action) this.callback(this.action, value)
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/question-tree-box/src/main.vue